module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('aside', {
    staticClass: "main-sidebar",
    attrs: {
      "id": "slider"
    }
  }, [_c('section', {
    staticClass: "sidebar"
  }, [_c('div', {
    staticClass: "user-panel"
  }, [_c('div', {
    staticClass: "text-center image"
  }, [_c('img', {
    staticClass: "profile-user-img",
    attrs: {
      "src": _vm.logo,
      "alt": "Company Logo"
    }
  }), _vm._v(" "), (_vm.getRecord.shortName) ? _c('p', {
    staticClass: "text-center"
  }, [_c('strong', [_vm._v(_vm._s(_vm.getRecord.shortName.toUpperCase()))])]) : _vm._e()]), _vm._v(" "), (this.$store.state.user.name) ? _c('div', {
    staticClass: " info"
  }, [_c('p', [_vm._v(" " + _vm._s(_vm.currentUser.name.toUpperCase()))]), _vm._v(" "), (_vm.currentUser.type === 'admin') ? _c('router-link', {
    attrs: {
      "to": "/"
    }
  }, [_c('i', {
    staticClass: "fa fa-circle",
    style: ("color:green;")
  }), _c('b', [_vm._v("Degn:")]), _vm._v(" Admin")]) : _vm._e(), _vm._v(" "), (_vm.currentUser.type === 'staff') ? _c('router-link', {
    attrs: {
      "to": "/"
    }
  }, [_c('i', {
    staticClass: "fa fa-circle",
    style: ("color:green;")
  }), _c('b', [_vm._v("Degn:")]), _vm._v(" " + _vm._s(_vm.currentUser.agent_profile.designation.name))]) : _vm._e()], 1) : _vm._e(), _c('br'), _c('br')]), _vm._v(" "), _c('ul', {
    staticClass: "sidebar-menu",
    attrs: {
      "data-widget": "tree"
    }
  }, _vm._l((_vm.slideMenuItems), function(item, index) {
    return _c('va-slide-item', {
      key: index,
      attrs: {
        "data": item,
        "type": item.type,
        "isHeader": item.isHeader,
        "icon": item.icon,
        "name": item.name,
        "badge": item.badge,
        "items": item.items,
        "router": item.router,
        "link": item.link
      }
    })
  }), 1)])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-6a2fd814!./~/vue-loader/lib/selector.js?type=template&index=0!./src/Slider.vue
// module id = 829
// module chunks = 0